module.exports = __webpack_public_path__ + "media/img/esquilete-e94995a3.png";